<div class="content">
  <div class="row chart-wrapper" *ngIf="single else noChart">
    <div class="col-12">
      <ngx-charts-area-chart
        [legend]="false"
        [yScaleMin]="0"
        [showXAxisLabel]="false"
        [showYAxisLabel]="false"
        [xAxis]="true"
        [yAxis]="true"
        [results]="single"
        [animations]="true"
        [showGridLines]="false"
        [gradient]="true"
        [xAxisTickFormatting]="formatDate"
        [scheme]="colorScheme"
        [rotateXAxisTicks]="true"
        style="fill: #FFFFFF">
        <ng-template #tooltipTemplate let-model="model">
          <div role="tooltip">
            <div>{{'chart.date' | transloco}} {{formatDate(model.name)}}</div>
            <div>{{'chart.amount' | transloco}} {{model.value}}</div>
          </div>
        </ng-template>
        <ng-template #seriesTooltipTemplate let-model="model">
          <div role="tooltip">
            <div>{{'chart.date' | transloco}} {{formatDate(model[0].name)}}</div>
            <div>{{'chart.amount' | transloco}} {{model[0].value}}</div>
          </div>
        </ng-template>
      </ngx-charts-area-chart>
    </div>
  </div>
  <ng-template #noChart>
    <div class="no-chart d-flex justify-content-center">
      <div class="gradient-text text-center">
        <span>
          {{'chart.noChartData' | transloco}}
        </span>
      </div>
    </div>
  </ng-template>
</div>
